/* eslint-disable indent */
"use client";

import { FC } from "react";
import { User } from "lucide-react";
import { Avatar, AvatarFallback, NextAvatarImage } from "@/components/ui/avatar";
import { cn } from "@/lib/utils";
import { getSubscriptionStyle } from "@/utils/utils";
import { UserPremiumType } from "types";
type SubscriptionAvatarProps = {
  userPremiumLevel?: UserPremiumType;
  avatarUrl?: string;
  username?: string;
  size?: "sm" | "md" | "lg" | "xl";
  onClick?: () => void;
};

/**
 * A component that displays an avatar with special styling based on subscription level
 */
export const SubscriptionAvatar: FC<SubscriptionAvatarProps> = ({
  userPremiumLevel = UserPremiumType.NONE,
  avatarUrl,
  username,
  size = "md",
  onClick
}) => {
  const sizeClasses = {
    sm: "!h-8 !w-8",
    md: "!h-12 !w-12",
    lg: "!h-20 !w-20",
    xl: "!h-32 !w-32"
  };

  // Get the subscription style based on the user's premium level
  const subscriptionStyle = getSubscriptionStyle(userPremiumLevel, true);
  return <div className={cn("rounded-full flex items-center justify-center overflow-hidden", subscriptionStyle, onClick && "cursor-pointer hover:opacity-90 transition-opacity")} onClick={onClick} data-sentry-component="SubscriptionAvatar" data-sentry-source-file="subscription-avatar.tsx">
            <Avatar className={cn("bg-slate-800", sizeClasses[size])} data-sentry-element="Avatar" data-sentry-source-file="subscription-avatar.tsx">
                {avatarUrl ? <NextAvatarImage src={avatarUrl} alt={username || "User"} size={size} /> : <AvatarFallback className="bg-slate-700 text-slate-200">
                        <User size={sizeClasses[size] === "h-8 w-8" ? 16 : sizeClasses[size] === "h-10 w-10" ? 20 : 24} />
                    </AvatarFallback>}
            </Avatar>
        </div>;
};